import { z } from "zod";

export const adClickAttributionSchema = z.object({
  click_id_type: z.enum(["gclid", "gbraid", "wbraid"]),
  click_id_value: z.string().trim().min(1).max(512),
  click_id_at: z.number().int().positive(),
});

export const metaEventContextSchema = z.object({
  eventId: z.string().uuid(),
  marketingConsent: z.boolean(),
  fbp: z.string().max(256).optional(),
  fbc: z.string().max(512).optional(),
  eventSourceUrl: z.string().max(2000).optional(),
  value: z.number().finite().nonnegative().optional(),
  currency: z
    .string()
    .trim()
    .regex(/^[A-Za-z]{3}$/)
    .optional(),
});

export type AdClickAttribution = z.infer<typeof adClickAttributionSchema>;
export type MetaEventContext = z.infer<typeof metaEventContextSchema>;
